import React, { useState, useEffect } from 'react';
import './Interface.css';
import Skill from './Skill/Skill';
import FightInfo from './FightInfo/FightInfo';

const Interface = ({ playerName, types, sendSpell, spells, canPlay, gameEnded }) => {

    const [descriptionText, setDescriptionText] = useState([{ text: "Welcome to this battle!" }]);

    const getSpellInfo = (spellInfo) => {
        setDescriptionText([...descriptionText, spellInfo]);
        sendSpell(spellInfo.info);
    }

    useEffect(() => {
        if (gameEnded) setDescriptionText([...descriptionText, {text: "End of the Game!"}]);
    }, [gameEnded])

    return (
        <div className="Interface">
            <div className="Description">
                { 
                    descriptionText.length ? descriptionText.map((description, index) => <FightInfo key={index} text={description} ID={index} />) : null
                 }
            </div>
            { canPlay &&
                <div className="Actions">
                    <div className="Skills">
                        {
                            spells.map((e, index) => <Skill sendSpellInfoToInterface={getSpellInfo} {...spells[index]} type={spells[index].type} playerName={playerName} />)
                        }
                    </div>
                </div>
            }
        </div>
    );
}

export default Interface;